module.exports = __webpack_public_path__ + "static/Teamcareers-6f46f33f3a4240f91e77940ec81e58d4.svg";